import { c as _c } from "react/compiler-runtime";
interface Props {
  count: number;
}
export function PlpResultCount(t0) {
  const $ = _c(3);
  const {
    count
  } = t0;
  const t1 = count === 1 ? "product" : "products";
  let t2;
  if ($[0] !== count || $[1] !== t1) {
    t2 = <p className="text-sm text-muted-foreground" data-testid="plp-result-count">Showing {count} {t1}</p>;
    $[0] = count;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}